import React from 'react';
import {Disclosure} from '@headlessui/react';

import {CaretIcon} from '../svg';
import {cx} from '../../util';

/**
 * Generic collapsible section: an accordion row with an optional small label
 * pill (e.g. "Deep dive") before the title. Collapsed by default.
 */
export const Collapsible = ({
  title = '',
  label,
  open = false,
  children,
}) => (
  <Disclosure
    as="div"
    defaultOpen={open}
    className="my-5 flex flex-col rounded-xl border border-gray-200 bg-white"
  >
    {({open: isOpen}) => (
      <>
        <Disclosure.Button className="group cursor-pointer rounded-xl text-left">
          <div className="flex flex-row items-center justify-between gap-3 px-5 py-3.5">
            <div className="flex min-w-0 items-center gap-2.5">
              {label && (
                <span className="shrink-0 rounded-full bg-indigo-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-indigo-600">
                  {label}
                </span>
              )}
              <span className="truncate text-[0.95em] font-semibold tracking-tight text-gray-900 group-hover:text-indigo-700">
                {title}
              </span>
            </div>
            <CaretIcon
              width={8}
              height={11}
              className={cx(isOpen ? 'rotate-90' : '-rotate-90', 'shrink-0 transform text-gray-400 transition-transform')}
              fill="currentColor"
            />
          </div>
        </Disclosure.Button>
        <Disclosure.Panel
          className="border-t border-gray-100 px-5 pt-3 pb-4 text-[0.95em] leading-[1.65] text-gray-700 *:first:mt-0! *:last:mb-0!"
          unmount={false}
        >
          {children}
        </Disclosure.Panel>
      </>
    )}
  </Disclosure>
);

export default Collapsible;
